module.exports = __webpack_public_path__ + "static/media/editor-icon-text-more.ffe887c3.svg";